var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeft = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M13.7 3.525 7.006 10l6.749 6.497L12.66 17.7l-6.956-6.705a1.454 1.454 0 0 1 0-2.089l6.869-6.562z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeft);
export default ForwardRef;